export default __webpack_public_path__ + "static/media/privacy_image.9190253e.png";